// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1dSfr","row":"Node_row__2UyD3","label":"Node_label__DI_gB","footer":"Node_footer__1X8QR"};